import React from 'react';
import { CheckIcon, ShieldCheckIcon } from 'lucide-react';
import { SectionCta } from '../SectionCta';
const included = ['Instant access to the digital materials.', 'All six practical volumes.', 'All five complementary bonuses.', 'Printable worksheets and templates.', 'A one-time payment of $27.', 'Seven-day refund protection.'];
export function Guarantee() {
  return <section className="bg-mist-50 px-4 py-16 md:px-8 md:py-24" data-id="element-181" data-mp="2edjag4ubaq4p">
      <div className="mx-auto max-w-3xl rounded-3xl bg-white p-6 text-center ring-2 ring-brand-400 md:p-12" data-id="element-182" data-mp="2ef4843bxap6s">
        <div className="mx-auto flex h-24 w-24 items-center justify-center rounded-full bg-brand-400 text-ink-950" data-id="element-183" data-mp="2jdxhbjk6fu15">
          <ShieldCheckIcon className="h-12 w-12" aria-hidden="true" data-id="element-184" data-mp="2sciybaa030zt" />
        </div>
        <p className="mt-5 text-sm font-extrabold uppercase tracking-wide text-brand-700" data-id="element-185" data-mp="tx68affxhkpf">Your purchase is protected</p>
        <h2 className="mt-2 text-[28px] font-extrabold leading-tight tracking-tight text-ink-900 md:text-4xl" data-id="element-186" data-mp="xy88ozll02sz">
          7-Day Digital Product Guarantee
        </h2>
        <p className="mt-4 text-[17px] leading-relaxed text-mist-600" data-id="element-187" data-mp="3snj6gju3e4cm">
          Explore the Endodontic Retreatment Decision Blueprint™ and review its practical clinical tools. If the
          resource isn't right for your professional needs, you may request a refund within seven days of purchase
          under the stated refund policy.
        </p>
        <ul className="mx-auto mt-8 grid max-w-xl gap-3 text-left sm:grid-cols-2" data-id="element-188" data-mp="fdvbbfz0j43c">
          {included.map(i => <li key={i} className="flex items-start gap-2.5 text-[15px] font-semibold text-ink-800" data-id="element-189" data-mp="agd1zoh32mut">
              <CheckIcon className="mt-0.5 h-5 w-5 shrink-0 text-brand-600" strokeWidth={3} aria-hidden="true" data-id="element-190" data-mp="5f5tfn749jn3" />
              {i}
            </li>)}
        </ul>
        <SectionCta label="Try it risk-free for 7 days" data-id="element-191" data-mp="2q77uwqoiw3z6" />
      </div>
    </section>;
}